import { render } from "./Bantuan.vue?vue&type=template&id=068319d4&scoped=true&ts=true"
import script from "./Bantuan.vue?vue&type=script&lang=ts"
export * from "./Bantuan.vue?vue&type=script&lang=ts"

import "./Bantuan.vue?vue&type=style&index=0&id=068319d4&lang=scss&scoped=true"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068319d4"]])

export default __exports__